import React, { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { getSupportOverview } from "../../redux/actions/dashboard";
import { useNavigate } from "react-router-dom";

export default function ActiveUsersByCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [companyFilter, setCompanyFilter] = useState("");

  useEffect(() => {
    dispatch(getSupportOverview());
  }, [dispatch]);

  const activeUsersList =
    useSelector(
      (state) =>
        state.dashboard.getAdminMonitoringDashboard.data?.active_users_list
    ) || [];

  const uniqueCompanies = Array.from(
    new Set(activeUsersList.map((d) => d.company))
  );

  const filteredData = companyFilter
    ? activeUsersList.filter((row) =>
        row.company?.toLowerCase().includes(companyFilter.toLowerCase())
      )
    : activeUsersList;

  return (
    <DashboardLayout>
      <Container maxWidth={false} sx={{ py: 4, px: 5 }}>
        {/* Flex wrapper */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={3}
        >
          <Box>
            <Select
              value={companyFilter}
              onChange={(e) => setCompanyFilter(e.target.value)}
              displayEmpty
              size="small"
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                mb: 4,
                width: "220px",
              }}
            >
              <MenuItem value="">All Companies</MenuItem>
              {uniqueCompanies.map((c) => (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
            <Typography
              variant="h6"
              fontWeight={600}
              mb={1}
              sx={{ textAlign: "left" }}
            >
              Active Users by Company
            </Typography>
          </Box>

          {/* Back button right */}
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              px: 4,
              borderColor: "#7B2D43",
              color: "#7B2D43",
              fontWeight: 500,
              "&:hover": {
                borderColor: "#7B2D43",
                backgroundColor: "transparent",
              },
            }}
            startIcon={<ArrowBack />}
          >
            Back
          </Button>
        </Box>

        <Box display="flex" justifyContent="center">
          <Paper
            elevation={0}
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #ddd",
              width: "100%",
              maxWidth: "600px",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#D0C5CA" }}>
                  <TableCell sx={{ fontWeight: 600 }}>Company</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    Total Number of Active Users
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{row.company || "Unknown"}</TableCell>
                      <TableCell>{row.active_user_count}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </Box>
      </Container>
    </DashboardLayout>
  );
}
